const parseFilterValue = filterValue => {
  if (!filterValue) {
    return {};
  }
  let root = {};
  const endExpression = (ptr, stack, expr, insert) => {
    const trimmedExpr = expr.trim();
    if (trimmedExpr) {
      if (!ptr.l) {
        ptr.l = trimmedExpr;
      } else if (!ptr.r) {
        ptr.r = trimmedExpr;
      } else {
        // bad expression
        return ptr;
      }
    }
    let newPtr = null;
    let prevPtr;
    do {
      prevPtr = newPtr;
      newPtr = stack.pop();
    } while (newPtr && newPtr.token !== '(');
    if (newPtr) {
      stack.push(newPtr);
      if (insert) {
        const insertedPtr = { ...newPtr };
        newPtr.l = insertedPtr;
        stack.push(insertedPtr);
        return insertedPtr;
      }
      return newPtr;
    }
    if (!insert) {
      return prevPtr;
    }
    root = {};
    root.l = prevPtr;
    stack.push(root);
    return root;
  };
  const startExpression = (ptr, stack) => {
    if (!ptr.l) {
      ptr.l = {};
      ptr = ptr.l;
    } else if (!ptr.r) {
      ptr.r = {};
      ptr = ptr.r;
    }
    stack.push(ptr);
    return ptr;
  };
  let ptr = root;
  let escaped = false;
  let expr = '';
  const stack = [root];
  for (let i = 0; i < filterValue.length; i += 1) {
    const c = filterValue[i];
    if (escaped) {
      escaped = false;
      expr += c;
    } else {
      escaped = false;
      if (c === '\\') {
        escaped = true;
      } else if (c === '(') {
        ptr = startExpression(ptr, stack);
        ptr.token = '(';
      } else if (c === ')') {
        ptr = endExpression(ptr, stack, expr);
        expr = '';
      } else if (c === '|' && filterValue[i + 1] === '|') {
        ptr = endExpression(ptr, stack, expr, true);
        ptr.token = 'OR';
        expr = '';
        i += 1;
      } else if (c === '&' && filterValue[i + 1] === '&') {
        ptr = endExpression(ptr, stack, expr, true);
        ptr.token = 'AND';
        expr = '';
        i += 1;
      } else if (c === '!') {
        ptr = startExpression(ptr, stack);
        ptr.token = 'NOT';
      } else {
        expr += c;
      }
    }
  }
  if (expr) {
    endExpression(ptr, stack, expr);
  }
  return root;
};

export function createFilter(filterValue, matchFunction) {
  const filterDefinition = parseFilterValue(filterValue);
  const filter = (fltDef, matchFunction, object) => {
    if (typeof fltDef === 'object') {
      if (fltDef.token) {
        if (fltDef.token === 'OR') {
          return filter(fltDef.l, matchFunction, object) || filter(fltDef.r, matchFunction, object);
        }
        if (fltDef.token === 'AND') {
          return filter(fltDef.l, matchFunction, object) && filter(fltDef.r, matchFunction, object);
        }
        if (fltDef.token === 'NOT') {
          return !filter(fltDef.l || fltDef.r, matchFunction, object);
        }
        return filter(fltDef.l, matchFunction, object);
      }
      if (typeof fltDef.l === 'object') {
        return filter(fltDef.l, matchFunction, object);
      }
      if (typeof fltDef.r === 'object') {
        return filter(fltDef.r, matchFunction, object);
      }
      if (fltDef.l) {
        return matchFunction(object, fltDef.l);
      }
      if (fltDef.r) {
        return matchFunction(object, fltDef.r);
      }
    }
    return matchFunction(object, fltDef);
  };
  return function (obj) {
    return filter(filterDefinition, matchFunction, obj);
  }
}



// WEBPACK FOOTER //
// ./src/selectors/FilterUtil.js